import {APIClient} from '../utils/APIClient';
import {API_URL} from '../settings/local_settings';
import {notifyOnboardingProgress} from '../utils/onboardingProgress';

// Capa API de la edición de una línea de control. Es el MISMO endpoint que usa la pantalla de
// edición completa (`BusinessUnitGlobalInfo`): el GET devuelve el paquete entero de la línea
// (nombre, presupuesto, moneda, metas parciales, período, objetivos, schedule, cuentas) y el PUT
// espera el paquete entero de vuelta — no hay update parcial. Quien edite un campo suelto (el
// drawer del Panel 2.1) tiene que leer primero y devolver el resto INTACTO, o pisa lo que no tocó.
const BASE = API_URL + 'business-unit/';

export const BusinessUnitEditApi = {
    get(businessUnitId) {
        return new APIClient(`${BASE}${encodeURIComponent(businessUnitId)}/edit`).call('GET');
    },

    // El paquete lleva presupuesto y objetivo, los dos ingredientes de «Deja tu tablero de control
    // listo»: guardar avisa al drawer de «Tus primeros pasos». Lo usa sólo el drawer de la 2.1.
    update(businessUnitId, data) {
        return new APIClient(`${BASE}${encodeURIComponent(businessUnitId)}/edit`).call('PUT', data)
            .then(notifyOnboardingProgress);
    },

    // Gestión de la línea — los MISMOS endpoints que usaba Monitoreo (la zona de gestión del
    // drawer es su reemplazo, card gtAL5axI). Reactivar puede responder
    // `AD_ACCOUNT_NOT_LINKED_TO_AGENCY_CLIENT`: las cuentas de la línea no están vinculadas al
    // cliente y el backend pide confirmación — se reintenta con `addAccountsToClient`.
    activate(businessUnitId, {addAccountsToClient = false} = {}) {
        return new APIClient(`${BASE}${encodeURIComponent(businessUnitId)}/activate`)
            .call('PUT', {add_ada_to_cli_if_none: addAccountsToClient});
    },

    deactivate(businessUnitId) {
        return new APIClient(`${BASE}${encodeURIComponent(businessUnitId)}/deactivate`)
            .call('PUT', {add_ada_to_cli_if_none: false});
    },

    // Borrado físico con CASCADE: el backend exige `{"confirm": true}` en el body (card 3itEavVM)
    // — el modal de confirmación del caller es quien garantiza que el usuario ya dijo que sí.
    remove(businessUnitId) {
        return new APIClient(`${BASE}${encodeURIComponent(businessUnitId)}/delete`)
            .call('DELETE', {confirm: true});
    },
};
